import { Snapshot } from "@/components/snapshot/Snapshot";
import { SnapshotContent } from "@/components/snapshot/SnapshotContent";
import { SnapshotHeader } from "@/components/snapshot/SnapshotHeader";
import { SnapshotPipeline } from "@/components/snapshot/SnapshotPipeline";
import { SnapshotSection } from "@/components/snapshot/SnapshotSection";
import { OrderSnapshotStatusImport } from "./OrderSnapshotStatusImport";

/** The Order snapshots page: one section per order export (TOE, Toll, eStore) to upload a day's files and build its snapshot, plus the status import step. */
export const OrderSnapshot = () => {
  return (
    <Snapshot>
      <SnapshotHeader title="Order snapshots" />
      <SnapshotContent>
        <SnapshotPipeline>
          <OrderSnapshotStatusImport />
        </SnapshotPipeline>
        <SnapshotSection
          label="TheOrderExchange"
          report="toe"
        />
        <SnapshotSection
          label="Toll"
          report="toll"
        />
        <SnapshotSection
          label="eStore"
          report="estore"
        />
      </SnapshotContent>
    </Snapshot>
  );
};
